import { toast } from '@bozic/ui/toast';
import { all, call, put, takeLatest } from 'redux-saga/effects';
import { getType, type ActionType } from 'typesafe-actions';

import { getErrorMessage } from '@/utils/invariant';

import insuranceAPI from '../../../services/insuranceService';
import { loadersActions } from '../../loaders/actions';

import { accountPreferencesActions } from './actions';

import type { AccountPreferencesDto } from '../../../types/dto/AccountPreferencesDto';
import type { AxiosResponse } from 'axios';

export function* fetchUserPreferences(
  action: ActionType<typeof accountPreferencesActions.userPreferences.fetchUserPreferences>
) {
  try {
    yield put(loadersActions.accountPreferencesLoader.activate());
    const preferences: AxiosResponse<AccountPreferencesDto> = yield call(
      insuranceAPI.getSpecifiedAccountPreferences,
      action.payload
    );
    yield put(accountPreferencesActions.userPreferences.setUserPreferences(preferences.data));
  } catch (error) {
    console.error(error);
  } finally {
    yield put(loadersActions.accountPreferencesLoader.disable());
    action.meta.setSpinner(false);
    action.meta.redirect();
  }
}

export function* putUserPreferences(
  action: ActionType<typeof accountPreferencesActions.userPreferences.saveUserPreferences>
) {
  try {
    yield put(loadersActions.accountPreferencesLoader.activate());
    yield call(insuranceAPI.updateSpecifiedAccountPreferences, action.payload, action.meta);
    yield toast.success('Changes Saved!', {
      position: 'top-right'
    });
  } catch (error) {
    toast.error(getErrorMessage(error), {
      position: 'top-right'
    });
  } finally {
    yield put(loadersActions.accountPreferencesLoader.disable());
  }
}

export default function* producerPreferencesSagaWatcher() {
  yield all([
    takeLatest(
      getType(accountPreferencesActions.userPreferences.fetchUserPreferences),
      fetchUserPreferences
    ),
    takeLatest(
      getType(accountPreferencesActions.userPreferences.saveUserPreferences),
      putUserPreferences
    )
  ]);
}
